//integracion de firestore en el proyecto
import { createStore, combineReducers, compose } from 'redux';
import { reactReduxFirebase, firebaseReducer } from 'react-redux-firebase';
import { reduxFirestore, firestoreReducer } from 'redux-firestore';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage'

// configurar firestore
const firebaseConfig = {
    apiKey: "AIzaSyDjr-MUKL7OrVnvKHYvO5s1hJkkOY4kyHI",
    authDomain: "dr-especialistas-militares.firebaseapp.com",
    projectId: "dr-especialistas-militares",
    storageBucket: "dr-especialistas-militares.appspot.com",
    messagingSenderId: "132089819927",
    appId: "1:132089819927:web:30867a71757ce8413c3d52",
    measurementId: "G-2Y1E239ZBY"
}

//configuracion de react-redux
const rrfConfig = {
    userProfile: 'users',
    useFirestoreForProfile: true
}

// inicializar firebase
firebase.initializeApp(firebaseConfig);

// Initialize other services on firebase instance
firebase.firestore() // <- needed if using firestore

// Reducers
const rootReducer = combineReducers({
    firebase: firebaseReducer,
    firestore: firestoreReducer
})

// crear el anlace con compose de redux y firestore
const createStoreWithFirebase = compose(
    reactReduxFirebase(firebase, rrfConfig),
    reduxFirestore(firebase)
)(createStore);

// state inicial
const initialState = {};

//crear el store
const store = createStoreWithFirebase(rootReducer, initialState)


export default store;